import { ShipmentStatus, shipmentStatusMap ,
	EnvirotainerContainerStatus,
	envirotainerContainerStatusMap , SortBy, sortByMap , SortDirection, sortDirectionMap } from "../enums";

export type TLoadDevicesQuery = {
	view: "map" | "cards";
	offset: number;
	limit: number;
	search?: string;
	countsFilter?: string;
	shipmentStatus: ShipmentStatus[];
	deviceStatus: EnvirotainerContainerStatus[];
	sortBy: SortBy;
	sortDirection: SortDirection;
};

export const printLoadDevicesQueryToRequest = (query: TLoadDevicesQuery): any => ({
	view: query.view,
	offset: query.offset,
	limit: query.limit,
	search: query.search,
	countsFilter: query.countsFilter || "Total",
	shipmentStatus: query.shipmentStatus.map(status => shipmentStatusMap.get(status)),
	deviceStatus: query.deviceStatus.map(status => envirotainerContainerStatusMap.get(status)),
	sortBy: sortByMap.get(query.sortBy)?.fieldName,
	order: sortDirectionMap.get(query.sortDirection),
});
